import {inject, Injectable} from '@angular/core';
import {Event, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavService {
    private router = inject(Router);


    public currentUrl = new BehaviorSubject<any>(undefined);

    constructor() {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl.next(event.urlAfterRedirects);
            }
        });
    }


}
